import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../Loader';
import MediaSearchAndPicker from '../MediaWrapper/MediaSearchAndPicker';
import MediaListDisplay from '../MediaWrapper/MediaListDisplay';
import LibraryListDisplay from '../MediaWrapper/LibraryListDisplay';
import LibraryMediaPicker from './LibraryMediaPicker';
import { thunkFetchEventMedia, clearLibrary } from '@/redux/actions';
import { Button } from 'antd';

class MediaLibraryPicker extends Component {
	state = {
		searchTerm: null,
		offset: 0,
		listType: 'thumbnail',
		page: 0,
		mediaPerPage: 10,
		mediaUploadDialogOpen: false,
		currentLibraryID: null,
	};

	componentDidMount = async () => {
		const from = 'MediaLibraryPicker.componentDidMount';
		this.handleFetchEventMedia(from);
	};

	handleFetchEventMedia = async from => {
		const { event, fetchEventMedia } = this.props;
		let { page, mediaPerPage, searchTerm } = this.state;
		await fetchEventMedia({
			event_id: event.id,
			search_term: searchTerm,
			items_per_page: mediaPerPage,
			offset: page * mediaPerPage,
		});
	};
	handleSearch = e => {
		const from = 'MediaLibraryPicker.handleSearch';
		if (e.target) {
			this.setState({ searchTerm: e.target.value, page: 0 }, () =>
				this.handleFetchEventMedia(from)
			);
		} else if (typeof e === 'string') {
			this.setState({ searchTerm: e, page: 0 }, () => this.handleFetchEventMedia(from));
		}
	};

	handlePageChange = page => () =>
		this.setState({ page }, () =>
			this.handleFetchEventMedia('MediaLibraryPicker.handlePageChanges')
		);

	changeListType = e => this.setState({ listType: e.target.value, page: 0 });

	setCurrentLibraryID = ({ id }) => e => {
		if (e && e.preventDefault) e.preventDefault();
		console.log('id', id);
		this.setState({ currentLibraryID: id });
	};
	render() {
		const { searchTerm, listType, page, mediaPerPage, currentLibraryID } = this.state;
		const {
			event,
			handlePickItem,
			stack,
			currentClient,
			mediaPicker,
			eventMedia,
			mediaPageInfo,
			clearLibrary,
		} = this.props;
		const { media, libraries } = eventMedia;
		const loading = !mediaPageInfo || (mediaPageInfo.total_count && !media.length);
		if (loading) return <Loader />;
		return stack === 'media' ? (
			<>
				<MediaSearchAndPicker
					searchTerm={searchTerm}
					handleSearch={this.handleSearch}
					listType={listType}
					changeListType={this.changeListType}
				/>
				<MediaListDisplay
					media={media}
					mediaPerPage={mediaPerPage}
					page={page}
					handlePageChange={this.handlePageChange}
					event={event}
					handlePickItem={handlePickItem}
					listType={listType}
					showHeader={false}
					refetch={from => this.handleFetchEventMedia(from)}
				/>
			</>
		) : currentLibraryID ? (
			<>
				<LibraryMediaPicker id={currentLibraryID} handlePickMedia={handlePickItem} event={event} />
				<Button
					onClick={() =>
						this.setState({ currentLibraryID: null }, () => clearLibrary('MediaLibraryPicker.back'))
					}
				>
					Back
				</Button>
			</>
		) : (
			<LibraryListDisplay
				libraries={libraries}
				event={event}
				client={currentClient}
				showHeader={false}
				handlePickItem={mediaPicker ? this.setCurrentLibraryID : handlePickItem}
			/>
		);
	}
}

const msp = ({ context, clients, eventMedia }) => ({
	currentClient: clients.currentClient,
	eventMedia,
	mediaPageInfo: context.mediaPageInfo,
});

const mdp = dispatch => ({
	fetchEventMedia: (queryParams, from) => dispatch(thunkFetchEventMedia(queryParams, from)),
	clearLibrary: from => dispatch(clearLibrary(from)),
});

export default connect(msp, mdp)(MediaLibraryPicker);
